/*!
 * 
 *
 * 	This file is auto generated by webpack.
 * 	Do not edit this file directly.
 *
 *
 */
/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 244:
/***/ (function() {

(function () {
  if (window.__pictogramTooltipsInit) return;
  window.__pictogramTooltipsInit = true;
  var isTouchDevice = false;
  var VIEWPORT_PADDING = 8;
  window.addEventListener('touchstart', function onFirstTouch() {
    isTouchDevice = true;
    window.removeEventListener('touchstart', onFirstTouch);
  }, {
    passive: true
  });

  function positionTooltip(pictogram) {
    var tooltip = pictogram.querySelector('.product-pictogram__tooltip');
    if (!tooltip) return;
    pictogram.classList.remove('tooltip-align-left', 'tooltip-align-right');
    tooltip.style.opacity = '0';
    tooltip.style.visibility = 'visible';
    var tipRect = tooltip.getBoundingClientRect();
    var viewportWidth = window.innerWidth;
    tooltip.style.opacity = '';
    tooltip.style.visibility = '';

    if (tipRect.left < VIEWPORT_PADDING) {
      pictogram.classList.add('tooltip-align-left');
    } else if (tipRect.right > viewportWidth - VIEWPORT_PADDING) {
      pictogram.classList.add('tooltip-align-right');
    }
  }

  function showTooltipAria(pictogram) {
    var tooltip = pictogram.querySelector('.product-pictogram__tooltip');

    if (tooltip && tooltip.id) {
      pictogram.setAttribute('aria-describedby', tooltip.id);
    }
  }

  function hideTooltipAria(pictogram) {
    pictogram.removeAttribute('aria-describedby');
    var tooltip = pictogram.querySelector('.product-pictogram__tooltip');
    if (tooltip) tooltip.setAttribute('aria-hidden', 'true');
  }

  function deactivatePictogram(el) {
    el.classList.remove('is-active');
    hideTooltipAria(el);
  }

  function getPictogramFromTarget(target) {
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest('.product-pictogram');
  }

  document.addEventListener('mouseenter', function (e) {
    var pictogram = getPictogramFromTarget(e.target);
    if (!pictogram) return;
    positionTooltip(pictogram);
    showTooltipAria(pictogram);
  }, true);
  document.addEventListener('mouseleave', function (e) {
    var pictogram = getPictogramFromTarget(e.target);
    if (pictogram) hideTooltipAria(pictogram);
  }, true);
  document.addEventListener('focusin', function (e) {
    var pictogram = getPictogramFromTarget(e.target);
    if (!pictogram) return;
    positionTooltip(pictogram);
    showTooltipAria(pictogram);
  }, true);
  document.addEventListener('focusout', function (e) {
    var pictogram = getPictogramFromTarget(e.target);
    if (pictogram) hideTooltipAria(pictogram);
  }, true);
  document.addEventListener('click', function (e) {
    if (!isTouchDevice) return;
    var pictogram = getPictogramFromTarget(e.target);
    document.querySelectorAll('.product-pictogram.is-active').forEach(function (el) {
      if (el !== pictogram) deactivatePictogram(el);
    });

    if (pictogram) {
      var tooltip = pictogram.querySelector('.product-pictogram__tooltip');
      if (!tooltip) return;
      positionTooltip(pictogram);
      var isActive = pictogram.classList.toggle('is-active');

      if (isActive) {
        showTooltipAria(pictogram);
        tooltip.setAttribute('aria-hidden', 'false');
      } else {
        hideTooltipAria(pictogram);
      }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.product-pictogram.is-active').forEach(deactivatePictogram);
    }
  });
})();

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
/* harmony import */ var _partials_product_pictograms__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(244);
/* harmony import */ var _partials_product_pictograms__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_partials_product_pictograms__WEBPACK_IMPORTED_MODULE_0__);



}();
/******/ })()
;